var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("company-name"),
        required: "",
        state: _vm.getState(_vm.$v.recipient.company_name),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.company_name),
      },
    },
    [
      _vm.canEdit
        ? _c("EmdInput", {
            attrs: {
              name: "company_name",
              readonly: _vm.disabled,
              disabled: _vm.disabled,
            },
            on: { input: () => _vm.$v.recipient.company_name.$touch() },
            model: {
              value: _vm.recipient.company_name,
              callback: function ($$v) {
                _vm.$set(_vm.recipient, "company_name", $$v)
              },
              expression: "recipient.company_name",
            },
          })
        : _c("span", [_vm._v(_vm._s(_vm.recipient.company_name))]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }